import React from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import '../styles/Footer.css';

const Footer: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const isActive = (path: string) => {
    if (path === '/main') {
      return location.pathname === '/main' || location.pathname.startsWith('/game');
    }
    return location.pathname === path;
  };

  return (
    <footer className="transparent-footer">
      <button 
        className={`footer-btn ${isActive('/wallet') ? 'active' : ''}`}
        onClick={() => navigate('/wallet')}
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M21 18V19C21 20.1 20.1 21 19 21H5C3.89 21 3 20.1 3 19V5C3 3.9 3.89 3 5 3H19C20.1 3 21 3.9 21 5V6H12C10.89 6 10 6.9 10 8V16C10 17.1 10.89 18 12 18H21ZM12 16H22V8H12V16ZM16 13.5C15.17 13.5 14.5 12.83 14.5 12C14.5 11.17 15.17 10.5 16 10.5C16.83 10.5 17.5 11.17 17.5 12C17.5 12.83 16.83 13.5 16 13.5Z" 
            fill="currentColor"
          />
        </svg>
        <span>Wallet</span>
      </button>

      <button 
        className={`footer-btn ${isActive('/main') ? 'active' : ''}`}
        onClick={() => navigate('/main')}
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M12 2L2 7V17H4V9.18L12 4.36L20 9.18V17H22V7L12 2Z" 
            fill="currentColor"
          />
          <path 
            d="M12 8.5L6 12V22H10V17H14V22H18V12L12 8.5Z" 
            fill="currentColor"
          />
        </svg>
        <span>Spil</span>
      </button>

      <button 
        className={`footer-btn ${isActive('/profil') ? 'active' : ''}`}
        onClick={() => navigate('/profil')}
      >
        <svg 
          width="24" 
          height="24" 
          viewBox="0 0 24 24" 
          fill="none" 
          xmlns="http://www.w3.org/2000/svg"
        >
          <path 
            d="M12 12C14.21 12 16 10.21 16 8C16 5.79 14.21 4 12 4C9.79 4 8 5.79 8 8C8 10.21 9.79 12 12 12ZM12 14C9.33 14 4 15.34 4 18V20H20V18C20 15.34 14.67 14 12 14Z" 
            fill="currentColor"
          />
        </svg>
        <span>Profil</span>
      </button>
    </footer>
  );
};

export default Footer;


